import React from 'react';
import { useZitoneoUI } from '../../contexts/ZitoneoUIContext';
import { VisibleContentScope } from '../../types/zitoneoServicesTypes';
import HotelServices from './HotelServices';
import RoomServices from './RoomServices';

const ServicesTab = () => {
    const { visibleContentScope } = useZitoneoUI();

    return visibleContentScope === VisibleContentScope.ROOM ? (
        <RoomServices />
    ) : (
        <HotelServices />
    );
};

export default ServicesTab;
